import React, { useState, useEffect, useMemo } from 'react'
import styled from '@emotion/styled'
import { Trash2 } from 'react-feather'

import VirtualOfficeService from 'Services/virtual-offices'

import { Tags } from 'Components/shared/Input'

import Table, { TableRow, TableCell } from 'Components/Table'
import { colors } from 'Constants'

import { navigate } from 'raviger'
import UsersService from 'Services/users'
import { toast } from 'react-toastify'
import { toastWithErrorMessage } from 'Helpers/toast'

const TagsCell = ({ data, column }) => {
  return (
    <Tags
      excludeClose
      tags={data[column.accessor].map(tag => ({ text: tag }))}
      style={{ cursor: 'pointer' }}
    />
  )
}

const CountCell = ({ data, column }) => <TableCell>{data[column.accessor].length}</TableCell>

const TableRowClickableStyle = styled(TableRow)`
  cursor: pointer;
  > * {
    transition: 0.2s background-color;
  }

  :hover {
    > * {
      background-color: ${colors.background900};
    }
  }
`

const TableRowClickable = ({ data, ...props }) => (
  <TableRowClickableStyle
    onClick={() => navigate(`/admin/virtual-offices?id=${data.id}`)}
    data={data}
    {...props}
  />
)

const columns = [
  {
    header: 'Title',
    accessor: 'title'
  },
  {
    header: 'Offices',
    accessor: 'officeTitles',
    Cell: TagsCell
  },
  {
    header: 'App Codes',
    accessor: 'appCodes',
    Cell: TagsCell
  },
  {
    header: '# of Invites',
    accessor: 'invites',
    Cell: CountCell,
    size: '0.5x'
  },
  {
    header: '# of Users',
    accessor: 'users',
    Cell: CountCell,
    size: '0.5x'
  }
]

export default () => {
  const [virtualOffices, setVirtualOffices] = useState([])

  useEffect(async () => {
    const retrievedVirtualOffices = await VirtualOfficeService.list()
    for (const virtualOffice of retrievedVirtualOffices) {
      virtualOffice.officeTitles = virtualOffice.offices.map(office => office.title)
    }
    setVirtualOffices(retrievedVirtualOffices)
  }, [])

  return <Table columns={columns} data={virtualOffices} Row={TableRowClickable} />
}

export const VirtualOfficeTableUser = ({ user, setUser }) => {
  const virtualOffices = useMemo(() => {
    const modifiedVirtualOffices = []
    if (user.virtualOffices)
      for (let virtualOffice of user.virtualOffices) {
        virtualOffice = { ...virtualOffice }
        virtualOffice.officeTitles = virtualOffice.offices.map(office => office.title)
        modifiedVirtualOffices.push(virtualOffice)
      }
    else if (user.virtualOfficeIds) {
      for (let virtualOffice of user.virtualOfficeIds) {
        virtualOffice = { ...virtualOffice }
        virtualOffice.officeTitles = virtualOffice.offices.map(office => office.title)
        modifiedVirtualOffices.push(virtualOffice)
      }
    }
    return modifiedVirtualOffices
  }, [user])

  const DeleteCell = ({ data }) => (
    <TableCell
      xAlign
      onClick={e => {
        e.stopPropagation()
        const selectedVirtualOffice = virtualOffices.find(
          virtualOffice => virtualOffice.title === data.title
        )
        if (!selectedVirtualOffice) return toast.error('Failed to find virtual office to delete')

        UsersService.removeVirtualOffices({
          userId: user.id,
          virtualOfficeIds: [selectedVirtualOffice.id]
        })
          .then(() => {
            user.virtualOfficeIds.splice(virtualOffices.indexOf(selectedVirtualOffice), 1)
            setUser({ ...user })
          })
          .catch(toastWithErrorMessage('Failed to remove virtual office'))
      }}
    >
      <Trash2 />
    </TableCell>
  )

  const columnsWithDelete = [
    ...columns,
    { header: 'Delete', size: '0.2x', accessor: 'delete', Cell: DeleteCell }
  ]

  return <Table columns={columnsWithDelete} data={virtualOffices} Row={TableRowClickable} />
}
